// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseRestQueryResult as baseQuery } from "@/services/api";
import { AuthUpdate } from "@/types/auth.type";
import { GET_ME_API, LOGIN_API, LOGOUT_API, UPDATE_ME_API } from "./path";

// Define a service using a base URL and expected endpoints
export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => ({
        url: LOGIN_API,
        method: 'POST',
        body,
      })
    }),
    getMe: builder.query({
      query: () => GET_ME_API,
    }),
    updateMe: builder.mutation<any, AuthUpdate>({
      query: (body) => ({
        url: UPDATE_ME_API,
        method: 'PUT',
        body,
      })
    }),
    logout: builder.mutation<any, any>({
      query: () => ({
        url: LOGOUT_API,
        method: "POST"
      })
    })
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLoginMutation, useGetMeQuery, useUpdateMeMutation, useLogoutMutation } = authApi;
